import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { TrendUp } from "@phosphor-icons/react";

export default function Signup() {
  const { register, formatApiError } = useAuth();
  const [form, setForm] = useState({ email: "", password: "", name: "" });
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form.email, form.password, form.name);
      toast.success("Account created");
      nav("/dashboard", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950 p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-8">
          <div className="h-9 w-9 rounded-lg bg-emerald-600 flex items-center justify-center">
            <TrendUp size={20} weight="bold" />
          </div>
          <span className="font-display text-lg font-semibold">Sirbansal</span>
        </div>
        <div className="text-xs uppercase tracking-[0.2em] text-emerald-500 font-bold">Create account</div>
        <h2 className="mt-2 font-display text-3xl">Start tracking your wealth</h2>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="signup-form">
          <div>
            <Label htmlFor="name">Name</Label>
            <Input id="name" data-testid="signup-name-input" value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="mt-1 bg-zinc-900 border-zinc-800" placeholder="Your name" />
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="signup-email-input" type="email" required value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="mt-1 bg-zinc-900 border-zinc-800" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" data-testid="signup-password-input" type="password" required minLength={6}
              value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="mt-1 bg-zinc-900 border-zinc-800" />
          </div>
          <Button type="submit" disabled={busy} data-testid="signup-submit-button"
            className="w-full bg-emerald-600 hover:bg-emerald-700 h-11">
            {busy ? "Creating…" : "Create account"}
          </Button>
        </form>
        <p className="mt-6 text-sm text-zinc-400 text-center">
          Already have an account?{" "}
          <Link to="/login" data-testid="go-to-login-link" className="text-emerald-400 hover:text-emerald-300 underline underline-offset-4">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
